export default "__VITE_ASSET__DVjpIkDF__"